var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reaction-button',{attrs:{"type":"subscribe","variant":"dark","icon-reacted":"fas fa-check","icon-unreacted":"fas fa-rss","id":_vm.id,"to":_vm.to}})}
var staticRenderFns = []

export { render, staticRenderFns }